var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkipIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7.004C14 7.40737 13.673 7.73437 13.2696 7.73437L5.48162 7.73437C5.07824 7.73437 4.75123 7.40737 4.75123 7.004C4.75123 6.60062 5.07824 6.27362 5.48162 6.27362L13.2696 6.27362C13.673 6.27362 14 6.60062 14 7.004Z",
    fill: "#0C002C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.27836 10.9891C8.99318 10.7038 8.99327 10.2414 9.27856 9.95619L12.2366 6.99937L9.27846 4.04133C8.99323 3.7561 8.99323 3.29365 9.27846 3.00842C9.5637 2.72319 10.0262 2.72319 10.3114 3.00842L13.7861 6.48302C13.9231 6.62001 14 6.80581 14 6.99954C14 7.19328 13.923 7.37906 13.786 7.51603L10.3113 10.9893C10.026 11.2745 9.56354 11.2744 9.27836 10.9891Z",
    fill: "#0C002C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.27758 11.8439C5.50652 11.8439 5.72607 11.753 5.88795 11.5911C6.04983 11.4292 6.14078 11.2097 6.14078 10.9808L6.14078 9.85598C6.14078 9.4526 6.46778 9.1256 6.87117 9.1256C7.27455 9.1256 7.60156 9.4526 7.60156 9.85598L7.60156 10.9808C7.60156 11.5971 7.35672 12.1882 6.92088 12.624C6.48505 13.0598 5.89394 13.3047 5.27758 13.3047L2.32414 13.3047C1.70778 13.3047 1.11667 13.0598 0.680837 12.624C0.245006 12.1882 0.000160367 11.5971 0.00016042 10.9808L0.000161116 3.02297C0.000418662 2.4068 0.245378 1.81564 0.681181 1.38003C1.11698 0.944418 1.70795 0.699707 2.32414 0.699708L5.27758 0.699708C5.89394 0.699708 6.48506 0.944553 6.92089 1.38037C7.35672 1.81619 7.60156 2.40729 7.60156 3.02364L7.60156 4.14576C7.60156 4.54914 7.27456 4.87614 6.87117 4.87614C6.46778 4.87614 6.14078 4.54914 6.14078 4.14576L6.14078 3.02364C6.14078 2.79471 6.04983 2.57516 5.88795 2.41328C5.72607 2.2514 5.50652 2.16046 5.27758 2.16046L2.32414 2.16046C2.09527 2.16046 1.87577 2.25135 1.7139 2.41315C1.55203 2.57495 1.46104 2.79441 1.46095 3.02328L1.46095 10.9808C1.46095 11.2097 1.55189 11.4292 1.71377 11.5911C1.87565 11.753 2.09521 11.8439 2.32414 11.8439L5.27758 11.8439Z",
    fill: "#0C002C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipIcon);
export default __webpack_public_path__ + "static/media/skipIcon.ceea3887fd72f911cf807f6ab4e35f02.svg";
export { ForwardRef as ReactComponent };